export default __webpack_public_path__ + "static/media/Img7.931a4605.png";